
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class FaqSection extends Vue {
  @Prop({ default: () => [] }) faqList!: Array<{
    question: string;
    answer: string;
  }>;
  @Prop({ default: "常见问题" }) title!: string;

  activeIndex = 0;

  toggleFaq(index: number) {
    this.activeIndex = this.activeIndex === index ? -1 : index;
  }
}
